import React from 'react';
import { SRLWrapper } from 'simple-react-lightbox';
import { WPBlock } from './types';

export interface WpLightBoxImageProps {
  block: WPBlock;
  showThumbnails?: boolean;
}

export default function WpLazyBlockLightBoxImage({
  block,
  showThumbnails,
}: WpLightBoxImageProps): JSX.Element | null {
  return (
    <div>
      <SRLWrapper
        options={{
          thumbnails: {
            showThumbnails: showThumbnails,
          },
        }}
      >
        <div
          dangerouslySetInnerHTML={{
            __html: block.isDynamic ? block.dynamicContent : block.saveContent,
          }}
        />
      </SRLWrapper>
    </div>
  );
}
